import {
  default as NavigationLinks,
  default as NavigationLinksPlebiscito,
} from '@plebiscito/Menu/NavigationLinks'
import styled from 'styled-components'

import { colors, spaces } from '@/config/global-parameters'

import YoutubeLiveVideo from '../YoutubeLiveVideo'
import Hamburger from './Hamburger'

const OLD_NAV_LINKS = [
  {
    href: '/2023/consejo/consejeros',
    key: 'general',
    label: 'Resultado general Consejeros',
    matchRegex: /\/2023\/consejo\/consejeros$/g,
  },
  {
    href: '/2023/consejo/circunscripciones',
    key: 'circunscripciones',
    label: 'Circunscripciones',
    matchRegex: /\/2023\/consejo\/circunscripciones\/(.*)$/g,
  },
  {
    href: '/2023/consejo/pueblos_indigenas',
    key: 'pueblos_indigenas',
    label: 'Pueblos Indígenas',
    matchRegex: /\/2023\/consejo\/pueblos_indigenas$/g,
  },
  {
    href: '/2023/consejo/candidatos',
    key: 'candidatos',
    label: 'Candidatas/os',
    matchRegex: /\/2023\/consejo\/candidatos*$/g,
  },
]

interface IMenu {
  className?: string
}

const Menu = ({ className }: IMenu) => {
  const youtubeId = process.env.NEXT_PUBLIC_YOUTUBE_ID
  return (
    <Wrapper className={className}>
      <Navigation>
        <Hamburger />
        <NavigationLinksPlebiscito />
        <NavigationLinks
          links={OLD_NAV_LINKS}
          onlySelector
          placeholder="Consejeros 2023"
        />
        {youtubeId && <YoutubeLiveVideo videoId={youtubeId} />}
      </Navigation>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  max-width: ${spaces.maxContent};
  padding: ${spaces.s} 0 ${spaces.s} ${spaces.m};
  background-color: ${colors.colorWhite};
  border-bottom: ${colors.headerGrey} solid 1px;
  border-top: ${colors.headerGrey} solid 1px;
`

const Navigation = styled.div`
  display: flex;
  justify-content: flex-start;
  overflow-x: auto;
  gap: 1.5em;
  align-items: center;
`

export default Menu
